module.exports = __webpack_public_path__ + "img/task.110ed2db.svg";